var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"1789298195742"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { init, replayIntegration } from '@sentry/nextjs';
import { shouldSkipReplayForError } from './utils/sentry-errors';

init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	debug: false,
	tracesSampleRate: 0,
	replaysOnErrorSampleRate: 1.0,
	replaysSessionSampleRate: 0,
	environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
	integrations: [
		replayIntegration({
			maskAllText: false,
			maskAllInputs: false,
			blockAllMedia: false,
			beforeErrorSampling: (event) => {
				// Skip replay quota for known non-actionable / diagnostic events.
				return !shouldSkipReplayForError(event)
			},
		}),
	],
	ignoreErrors: [
		'ResizeObserver loop limit exceeded',
		'ResizeObserver loop completed with undelivered notifications.',
		'getRestrictions is not a function',
		'Unexpected EOF',
		"Can't find variable: _AutofillCallbackHandler",
		'Non-Error promise rejection captured with value: Object Not Found',
		'Non-Error exception captured',
		'Non-Error promise rejection captured',
		'Error: ib',
		'Error: jb',
		'Error: Sd',
		'Error: Xd',
		'Error: Yd',
		'TypeError: Illegal invocation',
		"Cannot read properties of null (reading 'readyState')",
	],
});
